import React, { useEffect, useState } from "react"
import Block from "@bappweb/block"
import "../assets/style.scss"
import Button from "@bappweb/button"
import { useAppDispatch } from "../../../config/hook"
import { setIsfocusInput } from "src/projects/kredi-karti/state/focusInput"

const StickyHeader = ({ campaigns }) => {
  const dispatch = useAppDispatch()

  const handleFocusInput = () => {
    document.getElementById('identityNumber')?.focus();
    dispatch(
      setIsfocusInput({
        isFocusInput: true
      })
    )
  }

  return (
    <Block type="header" className="landing-header-container landing-header-container-red">
      <Block className="sticky fixed">
        <Block className="sticky-container">
          <Block className="sticky-content">
            <Block className="sticky-text" dangerouslySetInnerHTML={{ __html: campaigns }} >
            </Block>
            <Button
              text="Hemen Başvur" type="submit" className="btn-white sticky-button" disabled={false} secondary={true}
              onClick={handleFocusInput} />
          </Block>
        </Block>
      </Block>
    </Block>
  )
}

export default StickyHeader
